<template>
  <b-row v-if="customer_behavior_context_loaded" class="m-0">
    <b-col class="p-0" style="flex: auto;">
      <b-row align-h="end" style="flex-wrap: wrap-reverse;" class="mb-1 mr-2 ml-2">
        <b-col class="px-0">
          <b-row class="align-period-filters-center">
            <b-col class="col-lg-6 col-12 mb-2 px-0 px-lg-2">
              <origin-filter>
                <v-select
                  id="customer-behavior-origin-selector"
                  slot="options"
                  class="origin-selector col pl-2"
                  :clearable="false"
                  v-model="behaviorOriginSelected"
                  :options="site_or_order_origin"
                  @input="updateCustomerBehaviorContext()"/>
              </origin-filter>
            </b-col>

            <b-col class="col-lg-6 col-12 mb-2 px-0 px-lg-2">
              <generic-filter>
                <img slot="image" src="@/assets/period_icon.svg" alt="period_icon">
                <v-select
                  id="customer-behavior-period-selector"
                  slot="options"
                  class="origin-selector col pl-2"
                  :clearable="false"
                  :searchable="false"
                  v-model="periodSelected"
                  :options="periodOptions"
                  @input="updateCustomerBehaviorContext()"/>
              </generic-filter>
              <date-picker v-if="!isHidden" @date-selected="updateCustomerBehaviorContext"></date-picker>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import GenericFilter from '@/components/GenericFilter.vue'
import OriginFilter from '@/components/OriginFilter.vue'
import DatePicker from '@/components/DatePicker.vue'

export default {
  mounted() {
    this.behaviorOriginSelected.code = this.$store.getters.customerBehaviorOriginSelectedCode
    this.behaviorOriginSelected.label = this.site_or_order_origin[this.behaviorOriginSelectedIndex]
      ? this.site_or_order_origin[this.behaviorOriginSelectedIndex].label
      : 'Todas as origens'

    this.periodSelected.code = this.$store.getters.customerBehaviorPeriodSelectedCode
    this.periodSelected.label = this.periodTextArray[this.customerBehaviorPeriodSelectedIndex]
  },
  components: {
    GenericFilter,
    OriginFilter,
    DatePicker
  },
  data: () => ({
    isHidden: true,
    behaviorOriginSelected: {
      code: null,
      label: null
    },
    periodSelected: {
      code: null,
      label: null
    }
  }),
  computed: {
    customer_behavior_context_loaded() { return this.$store.getters.customer_behavior_context_loaded },
    site_or_order_origin() { return this.$store.getters.site_or_order_origin },
    behaviorOriginSelectedIndex() { return this.$store.getters.customerBehaviorOriginSelectedIndex },
    periodTextArray() { return this.$store.getters.periodTextArray },
    customerBehaviorPeriodSelectedIndex() { return this.$store.getters.customerBehaviorPeriodSelectedIndex },
    periodOptions() {
      return [
        { code: 0, label: this.periodTextArray[0] },
        { code: 1, label: this.periodTextArray[1] },
        { code: 2, label: this.periodTextArray[2] },
        { code: 3, label: this.periodTextArray[3] },
        { code: 4, label: this.periodTextArray[4] },
        { code: 5, label: this.periodTextArray[5] },
        { code: 6, label: this.periodTextArray[6] },
        { code: 7, label: this.periodTextArray[7] },
        { code: 8, label: this.periodTextArray[8] },
      ]
    }
  },
  methods: {
    updateCustomerBehaviorContext(date) {
      if (this.periodSelected.code === 8 && date === undefined) {
        this.periodSelected = 'Intervalo de Datas'
        this.isHidden = !this.isHidden;
        return
      } else if (this.periodSelected.code !== 8) {
        this.isHidden = true;
      }
      if (date !== undefined) {
        const payload = {
          'period': 8,
          'site_or_order_origin': this.behaviorOriginSelected.site_or_origin,
          'date_start': date.length === 2 ? date[0] : '',
          'date_end': date.length === 2 ? date[1] : date[0],
          'skipOrderContextRefresh': true,
        }
        this.$store.commit('updateCustomerBehaviorPeriodOriginSelectedIndex', {
          'period': payload.period,
          'origin': this.behaviorOriginSelected.code,
          'date_start': payload.date_start,
          'date_end': payload.date_end,
        })
        this.$store.commit('updateOrderPeriodContext', payload)
        this.$store.commit('updateCustomerBehaviorContext', payload)

        this.periodSelected = {}
        this.periodSelected.label = `${date.length === 2 ? this.dateFormat(date[0]) + ' ~ ' + this.dateFormat(date[1]) : this.dateFormat(date[0])}`
      } else {
        const payload = {
          'period': this.periodSelected.code,
          'site_or_order_origin': this.behaviorOriginSelected.site_or_origin,
          'skipOrderContextRefresh': true,
        }
        this.$store.commit('updateCustomerBehaviorPeriodOriginSelectedIndex', {
          'period': payload.period,
          'origin': this.behaviorOriginSelected.code,
        })
        this.$store.commit('updateOrderPeriodContext', payload)
        this.$store.commit('updateCustomerBehaviorContext', payload)
      }

      this.$store.commit('updateCustomerBehaviorPeriodSelectedCode', this.periodSelected.code)
      this.$store.commit('updateCustomerBehaviorOriginSelectedCode', this.behaviorOriginSelected.code)
    },
    dateFormat(date){
      return `${date.split('-').reverse().join('/')}`;
    }
  }
}
</script>

<style scoped lang="scss">
  .text-base {
    text-align: right;
  }

  @media only screen and (max-width: 576px) {
    .text-base {
      text-align: center !important;
    }
  }

  @media only screen and (max-width: 1000px) {
    div.align-period-filters-center {
      margin: 0 0 !important;
    }
  }

  .origin-selector {
    padding-right: 0;

    .vs__actions {
      position: absolute;
      right: 0px;
      top: 12px;
      padding: 0;
    }
    .vs__selected-options {
      max-height: 28px;

      .vs__selected {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }

  .align-period-filters-center {
    margin: 0 -8px !important;
  }
</style>

